import { Routes } from '@angular/router';
import { DashboardError404Page } from '@eforall/dashboard';
import { AdmissionsAcceleratorsPage } from './pages/admissions/accelerators/admissions-accelerators.page';
import { AdmissionsCommitmentsPage } from './pages/admissions/commitments/admissions-commitments.page';
import { AdmissionsEngagementsPage } from './pages/admissions/engagements/admissions-engagements.page';
import { AdmissionsManagerPage } from './pages/admissions/manager/admissions-manager.page';
import { AdmissionsOverviewPage } from './pages/admissions/overview/admissions-overview.page';
import { AdmissionsProspectsPage } from './pages/admissions/prospects/admissions-prospects.page';
import { AlumniPage } from './pages/alumni/alumni.page';

import { ConfigurationAcceleratorsPage } from './pages/configuration/accelerators/configuration-accelerators.page';
import { ConfigurationCommitmentsPage } from './pages/configuration/commitments/configuration-commitments.page';
import { ConfigurationEmailJobsPage } from './pages/configuration/email-jobs/configuration-email-jobs.page';
import { ConfigurationPlanningPage } from './pages/configuration/planning/configuration-planning.page';

import { DeliveryAcceleratorsPage } from './pages/delivery/accelerators/delivery-accelerators.page';
import { DeliveryEngagementsPage } from './pages/delivery/engagements/delivery-engagements.page';
import { DeliveryEventsPage } from './pages/delivery/events/delivery-events.page';
import { DeliveryOverviewPage } from './pages/delivery/overview/delivery-overview.page';

import { AccCohortPage } from './pages/delivery/accelerator/cohort/acc-cohort.page';
import { AccDeliveryPage } from './pages/delivery/accelerator/delivery/acc-delivery.page';

import { ExperienceAIAdvisorPage } from './pages/experience/ai-advisor/experience-ai-advisor.page';
import { ExperienceCoursesPage } from './pages/experience/courses/experience-courses.page';

import { ExperienceEngagementsPage } from './pages/experience/engagements/experience-engagements.page';
import { ExperienceOverviewPage } from './pages/experience/overview/experience-overview.page';
import { ExperienceSchedulingPage } from './pages/experience/scheduling/experience-scheduling.page';

import { VolunteeringAllVolunteersPage } from './pages/volunteering/all-volunteers/volunteering-all-volunteers.page';
import { VolunteeringEngagementsPage } from './pages/volunteering/engagements/volunteering-engagements.page';
import { VolunteeringMentorsPage } from './pages/volunteering/mentors/volunteering-mentors.page';
import { VolunteeringOverviewPage } from './pages/volunteering/overview/volunteering-overview.page';
import { VolunteeringProspectsPage } from './pages/volunteering/prospects/volunteering-prospects.page';
import { VolunteeringSpecialistsPage } from './pages/volunteering/specialists/volunteering-specialists.page';

import { FramePage } from './pages/frame/frame.page';
import { HomePage } from './pages/home/home.page';
import { TechPage } from './pages/tech/tech.page';

export const routes: Routes = [
	{
		path: '',
		component: FramePage,
		children: [
			{ path: '', component: HomePage },
			{ path: 'tech', component: TechPage },
			{
				path: 'configuration',
				data: { breadcrumb: 'Configuration' },
				children: [
					{ path: '', redirectTo: 'planning', pathMatch: 'full' },
					{ path: 'planning', component: ConfigurationPlanningPage, data: { breadcrumb: 'Planning', upUrl: '../..' } },
					{ path: 'accelerators', component: ConfigurationAcceleratorsPage, data: { breadcrumb: 'Accelerators', upUrl: '../..' } },
					{ path: 'commitments', component: ConfigurationCommitmentsPage, data: { breadcrumb: 'Commitments', upUrl: '../..' } },
					{ path: 'email-jobs', component: ConfigurationEmailJobsPage, data: { breadcrumb: 'Email Jobs', upUrl: '../..' } },
				]
			},
			// {
			// 	path: 'volunteer-recruitment',
			// 	data: { breadcrumb: 'Volunteer Recruitment' },
			// 	children: [
			// 		{ path: '', redirectTo: 'overview', pathMatch: 'full' },
			// 		{ path: 'overview', component: VolunteerRecruitmentOverviewPage, data: { breadcrumb: 'Overview', upUrl: '../..' } },
			// 		{ path: 'engagements', component: VolunteerRecruitmentEngagementsPage, data: { breadcrumb: 'Engagements' } },
			// 		{ path: 'prospects', component: VolunteerRecruitmentProspectsPage, data: { breadcrumb: 'Prospects' } },
			// 	]
			// },
			{
				path: 'volunteering',
				data: { breadcrumb: 'Volunteering' },
				children: [
					{ path: '', redirectTo: 'overview', pathMatch: 'full' },
					{ path: 'overview', component: VolunteeringOverviewPage, data: { breadcrumb: 'Overview', upUrl: '../..' } },
					{ path: 'engagements', component: VolunteeringEngagementsPage, data: { breadcrumb: 'Engagements' } },
					{ path: 'prospects', component: VolunteeringProspectsPage, data: { breadcrumb: 'Prospects' } },
					{ path: 'mentors', component: VolunteeringMentorsPage, data: { breadcrumb: 'Mentors' } },
					{ path: 'specialists', component: VolunteeringSpecialistsPage, data: { breadcrumb: 'Specialists' } },
					{ path: 'all-volunteers', component: VolunteeringAllVolunteersPage, data: { breadcrumb: 'All Volunteers' } },
				]
			},
			{
				path: 'admissions',
				data: { breadcrumb: 'Admissions' },
				children: [
					{ path: '', redirectTo: 'overview', pathMatch: 'full' },
					{ path: 'overview', component: AdmissionsOverviewPage, data: { breadcrumb: 'Overview', upUrl: '../..' } },
					{ path: 'commitments', component: AdmissionsCommitmentsPage, data: { breadcrumb: 'Commitments' } },
					{ path: 'engagements', component: AdmissionsEngagementsPage, data: { breadcrumb: 'Engagements' } },
					{ path: 'prospects', component: AdmissionsProspectsPage, data: { breadcrumb: 'Prospects' } },
					// { path: 'applications', component: AdmissionsApplicationsPage, data: { breadcrumb: 'Applications' } },
					{ path: 'accelerators', component: AdmissionsAcceleratorsPage, data: { breadcrumb: 'Accelerators' } },
					{ path: 'manager', component: AdmissionsManagerPage, data: { breadcrumb: 'Manager' } },
				]
			},
			{
				path: 'delivery',
				data: { breadcrumb: 'Delivery' },
				children: [
					{ path: '', redirectTo: 'overview', pathMatch: 'full' },
					{ path: 'overview', component: DeliveryOverviewPage, data: { breadcrumb: 'Overview', upUrl: '../..' } },
					{ path: 'engagements', component: DeliveryEngagementsPage, data: { breadcrumb: 'Engagements' } },
					{ path: 'events', component: DeliveryEventsPage, data: { breadcrumb: 'Events' } },
					{
						path: 'accelerators', data: { breadcrumb: 'Accelerators' },
						children: [
							{ path: '', component: DeliveryAcceleratorsPage },
							{
								path: ':accName', data: { breadcrumb: ':slug' }, children: [
									{ path: '', redirectTo: 'cohort', pathMatch: 'full' },
									{ path: 'cohort', component: AccCohortPage, data: { breadcrumb: 'Cohort', upUrl: '../..' } },
									{ path: 'delivery', component: AccDeliveryPage, data: { breadcrumb: 'Delivery', upUrl: '../..' } },
								]
							}
						]
					},
				]
			},
			{
				path: 'alumni',
				data: { breadcrumb: 'Alumni' },
				children: [
					{ path: '', component: AlumniPage },
				]
			},
			{
				path: 'experience',
				data: { breadcrumb: 'Experience' },
				children: [
					// { path: '', component: AdmissionsPage },
					{ path: '', redirectTo: 'courses', pathMatch: 'full' },
					{ path: 'overview', component: ExperienceOverviewPage, data: { breadcrumb: 'Overview', upUrl: '../..' } },
					{ path: 'engagements', component: ExperienceEngagementsPage, data: { breadcrumb: 'Engagements' } },
					{ path: 'courses', component: ExperienceCoursesPage, data: { breadcrumb: 'Courses' } },
					{ path: 'scheduling', component: ExperienceSchedulingPage, data: { breadcrumb: 'Scheduling' } },
					{ path: 'ai-advisor', component: ExperienceAIAdvisorPage, data: { breadcrumb: 'AI Advisor' } },
				]
			},
			//
			// Page not found
			//
			{ path: '**', component: DashboardError404Page },
		]
	}

];
